import {action, computed, observable} from "mobx";
import {API} from "../api";
import * as moment from "moment-timezone";
import {BundleData} from "./BundleData";

interface ILiveEvent {
  bundleId:string;
  fullName:string;
  solutions:string[];
  presentationStartTS:Date;
  presentationEndTS:Date;
  type:string;
  live:boolean;
}

export class LiveEvent implements ILiveEvent {

  bundleId:string;
  @observable presentationStartTS:Date;
  @observable presentationEndTS:Date;
  @observable live:boolean = false;
  @observable solutions:string[] = [];
  @observable fullName:string;
  @observable type:string;

  @action update(json:ILiveEvent) {
    this.presentationStartTS = json.presentationStartTS;
    this.presentationEndTS = json.presentationEndTS;
    this.live = json.live;
    this.solutions = json.solutions;
    this.fullName = json.fullName;
  }

  @computed get niceType() {
    return BundleData.niceTypeForBundleType(this.type);
  }

  @computed get startedAt() {
    if(this.live) {
      try {
        return this.niceType + " started at " + moment(this.presentationStartTS).tz(moment.tz.guess()).format("h:mm a, zz");
      } catch (e) {
        console.log(e);
      }
    }
    return null;
  }

  constructor(json:ILiveEvent) {
    this.bundleId = json.bundleId;
    this.update(json);
  }

}

class _LiveEventData {
  loadTimeout = 30 * 1000;
  @observable private stopped = true;
  @observable private loading = false;
  @observable liveEvents:LiveEvent[] = [];

  firstLiveEventForSolutionId = (solutionId:string) => {
    const liveEvent = LiveEventData.liveEvents.find(liveEvent=>{
      for (let i = 0; i < liveEvent.solutions.length; i++) {
        if (liveEvent.solutions[i]===solutionId){
          return true;
        }
      }
      return false;
    });
    return liveEvent;
  }

  liveEventForBundleId = (bundleId:string) => {
    return LiveEventData.liveEvents.find(liveEvent=>liveEvent.bundleId===bundleId);
  }

  @action private processLiveEvents = (liveEventsToProcess:ILiveEvent[]) => {
    const updatedLiveEvents:LiveEvent[] = [];
    for(let i=0;i<liveEventsToProcess.length;i++) {
      const liveEvent = this.liveEvents.find(liveEvent=>liveEvent.bundleId==liveEventsToProcess[i].bundleId);
      if(liveEvent) {
        liveEvent.update(liveEventsToProcess[i]);
        updatedLiveEvents.push(liveEvent);
      } else {
        updatedLiveEvents.push(new LiveEvent(liveEventsToProcess[i]));
      }
    }
    this.liveEvents = updatedLiveEvents
  }

  @action private loadLiveEvents = () => {
    if(!this.loading) {
      API.get('/liveEvents')
        .then((liveEvents:ILiveEvent[])=>{
          this.processLiveEvents(liveEvents);
          this.loading = false;
          setTimeout(this.loadLiveEvents, this.loadTimeout);
        })
        .catch((err)=>{
          console.log(err);
          this.loading = false;
          setTimeout(this.loadLiveEvents, this.loadTimeout);
        });
    }
  }

  @action start = () => {
    if(this.stopped) {
      this.stopped = false;
      this.loadLiveEvents();
    }
  }

  @action stop = () => {
    this.stopped = true;
  }

}

const LiveEventData = new _LiveEventData();
export default LiveEventData;
